/*jshint esversion: 6 */
const url = import.meta.env.VITE_APP_TARIFFS_API_URL;

// WIS API proxied via tariffs backend
export let wisService = {
    getCountryName: async (numericCountryCode) => {
        const response = await fetch(
            `${url}api/search-tree/1.0/labels/country_ISO/${numericCountryCode}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
        return await response.json();
    },
    getWorkHours: async (numericCountryCode) => {
        const response = await fetch(
            `${url}api/search-tree/1.0/mappings/HRSSTAND_WORKING/${numericCountryCode}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
        return await response.json();
    },
    occupationsGig: async (iscoCode) => {
        const response = await fetch(
            `${url}api/search-tree/1.0/mappings/occupations_GIGGIZ/${iscoCode}?slugify_keys=true`,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
        return await response.json();
    },
};
